import { Injectable } from '@angular/core';
import { Subject, Subscription, interval, timer } from 'rxjs';
import { AlertToast, AlertToastType } from '../interfaces/alert.interface';
import { Confirmation, ConfirmationService, MessageService } from 'primeng/api';
import { DateTimePickerOptions } from '../interfaces/event.interface';
import Swal from 'sweetalert2';

export const ALERT_TOAST_EVENT = new Subject<AlertToast>();
export const ALERT_LOADING_EVENT = new Subject<boolean>();

@Injectable({ providedIn: 'root' })
export class AlertService {

    // /** แจ้งเตือนธรรมดา */
    notify(message: string, severity: "success" | "info" | "error" | "warning" = "warning") {
        let Items = [
            { severity: 'success', btnText: 'ตกลง', icon: `check`, classIcon: 'alert success', confirmButton: 'btn  btn-primary', cancelButton: 'btn btn-outline-secondary me-2' },
            { severity: 'warning', btnText: 'ตกลง', icon: `warning`, classIcon: 'alert warning justify-content-center', confirmButton: 'btn  btn-primary', cancelButton: 'btn btn-outline-secondary me-2' },
            { severity: 'error', btnText: 'ตกลง', icon: `error`, classIcon: 'alert error justify-content-center', confirmButton: 'btn  btn-danger', cancelButton: 'btn btn-outline-secondary me-2' }
        ]
        let getItems = Items.find(fn => fn.severity == severity)
        return Swal.fire({

            position: "center",
            html: `
            <div class="mt-2 d-flex justify-content-center mb-3">
                <div class="${getItems?.classIcon}">
                     <span class="material-symbols-outlined">
                         ${getItems?.icon}
                    </span>
                 </div>
            </div>
            <b>${message}</b>`,
            showConfirmButton: false,
            timer: 1500
        });
    }

    // /** การยืนยันความต้องการลบข้อมูล */
    confirm(message: string = 'กรอกข้อความ', severity: "success" | "info" | "error" | "warning" = "warning") {
        let Items = [
            { severity: 'success', btnText: 'ตกลง', icon: `check`, classIcon: 'alert success justify-content-center', confirmButton: 'btn  btn-primary', cancelButton: 'btn btn-outline-secondary me-2' },
            { severity: 'warning', btnText: 'ตกลง', icon: `warning`, classIcon: 'alert warning justify-content-center', confirmButton: 'btn  btn-primary', cancelButton: 'btn btn-outline-secondary me-2' },
            { severity: 'error', btnText: 'ตกลง', icon: `error`, classIcon: 'alert error justify-content-center', confirmButton: 'btn  btn-danger', cancelButton: 'btn btn-outline-secondary me-2 ' }
        ]
        let getItems = Items.find(fn => fn.severity == severity)
        return Swal.fire({
            // title: 'header',
            html: `
            <div class="mt-2 d-flex justify-content-center mb-3">
                <div class="${getItems?.classIcon}">
                     <span class="material-symbols-outlined">
                         ${getItems?.icon}
                    </span>
                 </div>
            </div>
            <b>${message}</b>`,
            // icon: "warning",
            showCancelButton: true,
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ตกลง",
            reverseButtons: true,
            customClass: {
                confirmButton: getItems?.confirmButton,
                cancelButton: getItems?.cancelButton
            },
            buttonsStyling: false

        })
    }


    // /** แจ้งเตือนจากระบบ dialog */
    dialog(message: string, header: string = 'Notification from the system', severity: "success" | "info" | "error" | "warning" = "warning") {
        return Swal.fire({
            icon: severity,
            title: header,
            text: message,
            // footer: '<a href="#">Why do I have this issue?</a>'
        });
    }

}
